import amplitude from 'amplitude-js';

export const initAmplitude = (userId?: string | null, email?: string | null, company?: string | null) => {
  const instance = amplitude.getInstance();
  instance.init(process.env.AMPLITUDE_API_KEY || '');

  const userProps = {
    ...(email && { email }),
    ...(company && { company }),
  };

  if (userId) {
    instance.setUserId(userId);
    instance.setUserProperties(userProps);
  }
};

const useTracking = () => amplitude.getInstance();

export default useTracking;
